import { UserType } from "shared/types/user";

export function getTalkTimeColor(
  userId: string,
  users: { [id: string]: UserType },
  canParticipateInClassUserIds: string[],
) {
  const totalParticipantTalkTime = Object.values(users)
    .filter((user) => canParticipateInClassUserIds.includes(user.id))
    .reduce((total, user) => (user.classroom_talk_time || 0) + total, 0);
  const numberOfParticipants = canParticipateInClassUserIds.length;
  // The "ideal" fraction of talk time for each participant assumes all participants talk the same amount of time
  const idealTalkTimeFraction = 1 / numberOfParticipants;

  let talkTimeColor = "orange";
  if (totalParticipantTalkTime > 0) {
    const talkTimeFraction = (users[userId].classroom_talk_time || 0) / totalParticipantTalkTime;
    if (talkTimeFraction < idealTalkTimeFraction * 0.2) {
      talkTimeColor = "orange"; // low
    } else if (talkTimeFraction < idealTalkTimeFraction * 0.8) {
      talkTimeColor = "green"; // average
    } else {
      talkTimeColor = "blue"; // high
    }
  }

  return talkTimeColor;
}
